import { render, staticRenderFns } from "./GameLinksButton.vue?vue&type=template&id=9e81bfca&scoped=true"
import script from "./GameLinksButton.vue?vue&type=script&lang=ts"
export * from "./GameLinksButton.vue?vue&type=script&lang=ts"
import style0 from "./GameLinksButton.vue?vue&type=style&index=0&id=9e81bfca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e81bfca",
  null
  
)

export default component.exports